import { useWizard } from "react-use-wizard";
import React from "react";
import NavigateBack from "../../components/navigateBack";
import NameInput from "../../components/nameInput";
import stepMap from "./utils";

function NameStep({
  qKey,
  question,
  onSubmitHandler,
  state,
  isOpenedFromClinicQrCode = false,
}) {
  const { nextStep, goToStep } = useWizard();
  const _qKey = qKey;

  const onNextFn = (data) => {
    onSubmitHandler({ [_qKey]: data });
    // isOpenedFromClinicQrCode ? goToStep(stepMap["TREATING-DOC"]) : nextStep();

    //this change done to skip doctor selection
    isOpenedFromClinicQrCode
      ? goToStep(stepMap["PID"])
      : goToStep(stepMap["PREF-TREATING-LOC"]);
  };

  /*
    const isIC4ID = (patientId) => patientId.match(/^\d{8}$/) !== null;
    const fetchPIDURL = (patientId) => `/api/v1/users/search?patientId={$patientId}`;

    const fetchPatientDetails = (data) => {
        fetch(fetchPIDURL(), {
            method: "POST",
            headers: {
                "Content-Type": "application/json;charset=utf-8",
            },
            body: JSON.stringify({
                tid: token,
                ...data,
            }),
        })
            .then((response) => response.json())
            .then((responseData) => {
                if (responseData["status"]["success"]) {
                    onSubmitHandler({ [_qKey]: data });
                    nextStep();
                }
            });
    };    
     */

  return (
    <>
      <NavigateBack />
      <NameInput
        nameDetails={state}
        question={question}
        onSubmitHandler={onNextFn}
      />
    </>
  );
}

export default NameStep;
